import React from 'react';
import { Col, Row } from 'reactstrap';
import { Grid, ThemeProvider, Typography } from '@mui/material';
import { translate } from 'react-jhipster';
import { isBoubyanQuotation } from 'app/shared/util/quotation-utils';

// TODO refactor to reduce input params and move data into internal state where possible
export const TransactionForms = ({
  createdByBankStaff,
  responsiveFont,
  isLocalCommodity,
  quotationEntity,
  getPurchaseColor,
  getTransferColor,
  getSellColor,
}) => {
  return (
    <Row className="justify-content-center" style={{ marginTop: '12px' }} hidden={createdByBankStaff?.bank?.transaction_forms === false}>
      <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '28px 42px 28px 42px' }}>
        <ThemeProvider theme={responsiveFont}>
          <Typography variant="h6" component="div">
            <strong>{translate('comexApp.quotation.transactionFormsHeading')}</strong>
          </Typography>
        </ThemeProvider>
        <Grid style={{ marginTop: '24px' }} className="row">
          <Grid item xs={12} sm={4} md={4}>
            {isLocalCommodity ? (
              quotationEntity?.localCommodityBidCertId !== null ? (
                <a href={`/quotation/${isBoubyanQuotation(quotationEntity) ? 'boubyan/local-transaction-forms-purchase' : 'local-transaction-forms-purchase'}/${quotationEntity?.id}`} target="_blank"
                   rel="noopener noreferrer">
                  <p style={{textAlign: 'center', color: getPurchaseColor()}}>
                    <u>{translate('comexApp.quotation.purchaseBtnLabel')}</u>
                  </p>
                </a>
              ) : (
                <p style={{ textAlign: 'center', color: getPurchaseColor() }}>
                  <u>{translate('comexApp.quotation.purchaseBtnLabel')}</u>
                </p>
              )
            ) : (
              quotationEntity?.bursaAPIBidCertId !== null ? (
                <a href={`/quotation/${isBoubyanQuotation(quotationEntity) ? 'boubyan/transaction-forms-purchase' : 'transaction-forms-purchase'}/${quotationEntity?.id}`} target="_blank" rel="noopener noreferrer">
                  <p style={{ textAlign: 'center', color: getPurchaseColor() }}>
                    <u>{translate('comexApp.quotation.purchaseBtnLabel')}</u>
                  </p>
                </a>
              ) : (
                <p style={{ textAlign: 'center', color: getPurchaseColor() }}>
                  <u>{translate('comexApp.quotation.purchaseBtnLabel')}</u>
                </p>
              )
            )}
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            {isLocalCommodity ? (
              quotationEntity?.localCommodityOtcCertId !== null ? (
                <a href={`/quotation/${isBoubyanQuotation(quotationEntity) ? 'boubyan/local-transaction-forms-transfer' : 'local-transaction-forms-transfer'}/${quotationEntity?.id}`} target="_blank"
                   rel="noopener noreferrer">
                  <p style={{textAlign: 'center', color: getTransferColor()}}>
                    <u>{translate('comexApp.quotation.transferBtnLabel')}</u></p>
                </a>
              ) : (
                <p style={{ textAlign: 'center', color: getTransferColor() }}>
                  <u>{translate('comexApp.quotation.transferBtnLabel')}</u>
                </p>
              )
            ) : (
              quotationEntity?.bursaAPIOtcCertId !== null ? (
                <a href={`/quotation/${isBoubyanQuotation(quotationEntity) ? 'boubyan/transaction-forms-transfer' : 'transaction-forms-transfer'}/${quotationEntity?.id}`} target="_blank"
                   rel="noopener noreferrer">
                  <p style={{textAlign: 'center', color: getTransferColor()}}>
                    <u>{translate('comexApp.quotation.transferBtnLabel')}</u></p>
                </a>
              ) : (
                <p style={{textAlign: 'center', color: getTransferColor()}}>
                  <u>{translate('comexApp.quotation.transferBtnLabel')}</u></p>
              )
            )}
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            {isLocalCommodity ? (
              quotationEntity?.localCommodityStbCertId !== null ? (
                <a href={`/quotation/${isBoubyanQuotation(quotationEntity) ? 'boubyan/local-transaction-forms-sell' : 'local-transaction-forms-sell'}/${quotationEntity?.id}`} target="_blank"
                   rel="noopener noreferrer">
                  <p style={{textAlign: 'center', color: getSellColor()}}>
                    <u>{translate('comexApp.quotation.sellBtnLabel')}</u></p>
                </a>
              ) : (
                <p style={{ textAlign: 'center', color: getSellColor() }}>
                  <u>{translate('comexApp.quotation.sellBtnLabel')}</u>
                </p>
              )
            ) : (
              quotationEntity?.bursaAPIStbCertId !== null ? (
                <a href={`/quotation/${isBoubyanQuotation(quotationEntity) ? 'boubyan/transaction-forms-sell' : 'transaction-forms-sell'}/${quotationEntity?.id}`} target="_blank"
                   rel="noopener noreferrer">
                  <p style={{textAlign: 'center', color: getSellColor()}}>
                    <u>{translate('comexApp.quotation.sellBtnLabel')}</u></p>
                </a>
              ) : (
                <p style={{textAlign: 'center', color: getSellColor()}}>
                  <u>{translate('comexApp.quotation.sellBtnLabel')}</u></p>
              )
            )}
          </Grid>
        </Grid>
      </Col>
    </Row>
  );
};
